import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { campsenum } from '../../../../../models/enums.generated';
import { CampsEnumTranslationService } from '../../../../../services/camps-enum-translation.service';
import { CampsDetailsFormStateService } from '../../camp-details-form-state-service';

@Component({
    selector: 'app-discount-details',
    templateUrl: './discount-details.component.html',
    styleUrls: ['./discount-details.component.scss'],
    standalone: false
})
export class DiscountDetailsComponent implements OnInit {
  
    @Input() public form : UntypedFormGroup;

    @Output() removed: EventEmitter<UntypedFormGroup> = new EventEmitter();

    constructor(
        public state : CampsDetailsFormStateService, 
        private enumTranslation : CampsEnumTranslationService,
        private translate : TranslateService ) { 

    }

    ngOnInit(): void {
     
    }


    public get isOtherItemEdited(){
        return this.state.isOtherItemEdited(this.form);
    }


    public edit(){
        this.state.markAsEdited(this.form);
    }

    public remove(){
        this.removed.emit(this.form)
    }

    public translateType(discount: campsenum.DiscountType){
        return this.enumTranslation.discountType(discount);
    }

    public translateTier(tier: campsenum.MembershipTier){
        return this.enumTranslation.membershipTier(tier);
    }

    public get discountType(){
        return this.form.controls['type'].value;
    }

    public get isSiblings(){
        return this.discountType == campsenum.DiscountType.Siblings;
    }

    public get isEarlyBird(){
        return this.discountType == campsenum.DiscountType.EarlyBird;
    }

    public get isTier(){
        return this.discountType == campsenum.DiscountType.MembershipTier;
    }

    public get isNumberOfDays(){
        return this.discountType == campsenum.DiscountType.NumberOfDays;
    }

    public get isEnrollmentDays(){
        return this.discountType == campsenum.DiscountType.EnrollmentDays;
    }

    public get isPif(){
        return this.discountType == campsenum.DiscountType.PayInFull;
    }

    public discountDetailsLabel(){
        return this.translate.instant("CampDetails.DiscountDetails" + campsenum.DiscountType[this.discountType]);
    }
}
